import { useFormContext } from "react-hook-form";
import { Text, Button } from "$components";
import useJStyles from "$hooks/useJStyles";
import { useStyles } from "../styles";
import { useEntrepotForm } from "../context/EntrepotFormContext";
import { EntrepotFormBasicInfo } from "./EntrepotFormBasicInfo";
import { EntrepotFormActivities } from "./EntrepotFormActivities";
import { EntrepotFormDelivery } from "./EntrepotFormDelivery";
import { EntrepotFormCompanies } from "./EntrepotFormCompanies";
import { EntrepotFormAttachments } from "./EntrepotFormAttachments";
import useOrder from "$hooks/useOrder";

type Props = {
  onSubmit: any;
  onReset: any;
};

export default function EntrepotFormContent({ onSubmit, onReset }: Props) {
  const form = useFormContext();
  const { jclasses } = useJStyles();
  const { errorContainer } = useStyles();
  const { entrepot, currentParentCompany, isSubmitting, entrepotError } =
    useEntrepotForm();
  const { classes } = useOrder();

  return (
    <div className={jclasses.jWrapper}>
      <form onSubmit={form.handleSubmit(onSubmit)} className={classes.form}>
        <div className={jclasses.formSectionHead}>
          <Text type="h3">Informations</Text>
        </div>
        <EntrepotFormBasicInfo />
        <EntrepotFormDelivery />
        <EntrepotFormActivities />
        {currentParentCompany && <EntrepotFormCompanies />}
        {entrepot && <EntrepotFormAttachments />}
        {entrepotError && (
          <Text className={errorContainer}>{entrepotError}</Text>
        )}
        <div className={jclasses.footerForm}>
          <Button color="secondary" onClick={onReset}>
            Annuler
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            {entrepot ? "Enregistrer" : "Créer"}
          </Button>
        </div>
      </form>
    </div>
  );
}
